import { render, staticRenderFns } from "./catalog.vue?vue&type=template&id=5c18e80b"
import script from "./catalog.vue?vue&type=script&lang=js"
export * from "./catalog.vue?vue&type=script&lang=js"
import style0 from "./catalog.vue?vue&type=style&index=0&id=5c18e80b&prod&lang=scss"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Breadcrumbs: require('/app/components/global/breadcrumbs.vue').default,Daily: require('/app/components/catalog/Daily.vue').default,IconCol1: require('/app/components/v2/icons/IconCol1.vue').default,VBtn: require('/app/node_modules/vuetify/lib/components/VBtn/VBtn.js').default,IconList: require('/app/components/icons/IconList.vue').default,IconCatalogCol2: require('/app/components/icons/IconCatalogCol2.vue').default,VBtnToggle: require('/app/node_modules/vuetify/lib/components/VBtnToggle/VBtnToggle.js').default})


/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
installComponents(component, {VBtn,VBtnToggle})
